import React from 'react';
import { motion } from 'framer-motion';
export function OtlEnvironmental() {
  return <div className="mb-24 grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-272">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} data-id="element-273">
        <h3 className="font-serif text-2xl text-forest mb-4" data-id="element-274">
          ¿Qué diferencia a un OTL ambiental?
        </h3>
        <div className="space-y-4 text-charcoal/80 font-light leading-relaxed text-sm" data-id="element-275">
          <p data-id="element-276">
            Un OTL ambiental es una figura territorial legal que está
            relacionada con la conservación, protección, ordenamiento, manejo o
            uso sostenible de los recursos naturales. Su propósito principal es
            ayudar a cuidar ecosistemas estratégicos, fuentes hídricas, áreas
            protegidas, reservas forestales, cuencas y otros espacios de
            importancia ambiental.
          </p>
          <p data-id="element-277">
            La diferencia frente a otros OTL radica en su finalidad y enfoque
            normativo. Mientras algunos objetos pueden estar asociados a temas
            administrativos, catastrales, productivos o de infraestructura, los
            OTL ambientales ponen en el centro la relación entre el espacio
            geográfico delimitado, la naturaleza y las decisiones que garantizan
            su protección y uso responsable.
          </p>
        </div>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      delay: 0.1
    }} data-id="element-278">
        <h3 className="font-serif text-2xl text-forest mb-4" data-id="element-279">
          Los OTL y el Catastro Multipropósito
        </h3>
        <div className="space-y-4 text-charcoal/80 font-light leading-relaxed text-sm" data-id="element-280">
          <p data-id="element-281">
            Los OTL también son importantes para el Catastro Multipropósito,
            porque permiten relacionar la información ambiental con la
            información predial y territorial. Esto ayuda a comprender mejor las
            condiciones que existen sobre un área o un predio, incluyendo
            posibles derechos, restricciones o responsabilidades.
          </p>
          <p data-id="element-282">
            Para facilitar este intercambio de información se utiliza{' '}
            <strong className="font-medium text-charcoal" data-id="element-283">LADM_COL</strong>, un
            modelo que permite organizar los datos geoespaciales de forma
            estandarizada. Gracias a este lenguaje común, diferentes entidades
            pueden compartir información de manera ordenada, interoperable y
            coherente.
          </p>
          <p data-id="element-284">
            En términos simples, los OTL permiten que la información ambiental y
            la información catastral "conversen" entre sí. Gracias a este
            avance, Colombia se ha convertido en el primer país de Latinoamérica
            en desarrollar OTL ambientales diseñados para interoperar con el
            Catastro Multipropósito.
          </p>
        </div>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      delay: 0.2
    }} data-id="element-285">
        <h3 className="font-serif text-2xl text-forest mb-4" data-id="element-286">
          Relación con el SIAC
        </h3>
        <div className="space-y-4 text-charcoal/80 font-light leading-relaxed text-sm" data-id="element-287">
          <p data-id="element-288">
            Los OTL fortalecen la información disponible para el Sistema de
            Información Ambiental de Colombia (SIAC), al aportar datos
            estructurados sobre figuras ambientales y áreas geográficas
            delimitadas con efectos jurídicos. Su incorporación facilita que la
            información pueda ser consultada, compartida y aprovechada por
            distintos usuarios.
          </p>
          <p data-id="element-289">
            Esta relación es importante porque el SIAC cumple un papel
            articulador en la gestión de la información ambiental del país. Los
            OTL contribuyen a mejorar la calidad, organización y disponibilidad
            de esa información para apoyar la toma de decisiones.
          </p>
        </div>
      </motion.div>
    </div>;
}